import { render, staticRenderFns } from "./saleCustomerInvoice.vue?vue&type=template&id=4496b2c8&scoped=true&"
import script from "./saleCustomerInvoice.vue?vue&type=script&lang=js&"
export * from "./saleCustomerInvoice.vue?vue&type=script&lang=js&"
import style0 from "./saleCustomerInvoice.vue?vue&type=style&index=0&id=4496b2c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4496b2c8",
  null
  
)

export default component.exports